export default __webpack_public_path__ + "static/media/bg19.8caf499b.jpg";